import dayjs from 'dayjs';

const convertHourStringToDecimal = (timeStr) => {
  if (!timeStr) return 0;
  const match = timeStr.match(/(?:(\d+)h)?\s*(?:(\d+)m)?/);
  if (!match) return 0;
  const hours = parseInt(match[1] || '0', 10);
  const minutes = parseInt(match[2] || '0', 10);
  return +(hours + minutes / 60).toFixed(2);
};

const transformBillableData = (apiData = []) => {
  return apiData.map(entry => ({
    label: dayjs(entry.date).format('D MMM'),
    billableHours: convertHourStringToDecimal(entry.billableHours),
    nonBillableHours: convertHourStringToDecimal(entry.nonBillableHours)
  }));
};

const BillableData = (options) => {

  const data = transformBillableData(options);

  if (!data || data.length === 0) return {};
  const useDataZoom = data.length > 15;
  const keys = Object.keys(data[0]).filter(k => k !== 'label');
  const labels = data.map(item => item.label);

  const colors = ['#EE6666', '#5470C6', '#91CC75', '#FAC858', '#73C0DE', '#3BA272'];

  return {
    color: colors,
    tooltip: {
      trigger: 'axis',
      formatter: params =>
        params.map(p => `${p.marker} ${p.seriesName}: ${p.data} hours`).join('<br/>')
    },
    legend: {show: false},
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 35 : 35,
      top: 40,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: labels
    },
    yAxis: {
      type: 'value',
      min: 0
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          xAxisIndex: 0,
          start: 0,
          end: 40,
          height: 15,
          bottom: 10
        }
      ]
      : [],
    series: keys.map((key, index) => ({
      name: key,
      type: 'line',
      data: data.map(d => d[key]),
      smooth: true,
      symbol: 'dot',
      lineStyle: {
        width: 2,
        color: colors[index % colors.length]
      },
      areaStyle: undefined // Remove area gradient
    }))


  };
};

export default BillableData;
